import { render, staticRenderFns } from "./AILessonBuilder.vue?vue&type=template&id=3f2bbf76"
import script from "./AILessonBuilder.vue?vue&type=script&lang=js"
export * from "./AILessonBuilder.vue?vue&type=script&lang=js"
import style0 from "./AILessonBuilder.vue?vue&type=style&index=0&id=3f2bbf76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports